"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implemented by objects providing a specific view
 */
var View = /** @class */ (function () {
    function View() {
        /**
         * This {@link View} sort
         *
         * @remarks
         * By default, even if this {@link View} is sortable, there can be no sort
         */
        this.sort = null;
        /**
         * This {@link View} filter
         *
         * @remarks
         * By default, even if this {@link View} is filterable, there can be no filter
         */
        this.filter = null;
    }
    /**
     * (Re)Define this {@link View} configuration
     * @param configuration
     */
    View.prototype.setConfiguration = function (configuration) {
        this.configuration = configuration;
    };
    return View;
}());
exports.View = View;
//# sourceMappingURL=View.js.map